import type { ChangelogEntry } from "../types";

/** Kundelogoer fra kundens egen nettside, også når bare e-posten har domenet (VIB-2892). */
export const KUNDELOGOER_2026_10: ChangelogEntry = {
  id: "2026-10-25-kundelogoer",
  date: "2026-10-25",
  title: "Flere kunder får logo",
  summary:
    "Logoen hentes nå også når Brønnøysund mangler nettside, fra domenet i kundens e-post, og synken velger selve logoen på nettsiden i stedet for bare det lille ikonet.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "Logo fra kundens nettside",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Har kunden ingen nettside i Brønnøysund, brukes domenet i kontakt- eller faktura-e-posten. Gmail og andre frie e-postadresser gir fortsatt initialer. Opptil 200 nye logoer hentes hver natt, og «Oppdater nå» på kundekortet henter med en gang.",
        },
      ],
    },
  ],
};
